export const getWebWelcomeToken = (): Promise<string | null> => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return Promise.resolve(urlSearchParams.get('key'));
};
